const BalloonsFrontPage = ({ isActiveWomensMode }) => {
    return (
        <>
            <div className='FrontPage--Riddle__Screen__Background'>
                {isActiveWomensMode ? (
                    // <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='FrontPage--Riddle__Screen__Background__Image' />
                    <img src='/img/games/balloons/background.jpeg' className='FrontPage--Riddle__Screen__Background__Image' />
                ) : isActiveWomensMode === false && (
                    // <img src='/img/page/backgrounds/background.png' className='FrontPage--Riddle__Screen__Background__Image' />
                    <img src='/img/games/balloons/background.jpeg' className='FrontPage--Riddle__Screen__Background__Image' />
                )}
            </div>

            <div className="FrontPage--Riddle__Screen__Container">
                <img src='/img/page/adsl-five.png' className='FrontPage--Riddle__Screen__Container__Logo' />

                <p className="FrontPage--Riddle__Screen__Container__Subtitle text-center mt-5 fs-1" style={{ fontFamily: '"GFS Didot", serif' }}>PRESENTAN</p>
                <p className="FrontPage--Riddle__Screen__Container__Title" style={{ fontFamily: '"GFS Didot", serif' }}>INFLAR BALONES</p>
                <img src="/img/games/runtogoal/balon-grande.png" className="FrontPage--Riddle__Screen__Container__BrandLogo mt-5" style={{ width: '300px' }} />
            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
        </>
    )
}

export { BalloonsFrontPage };